import { GridFilterModel } from '@mui/x-data-grid';

export function parseFilterModel(filterModel: GridFilterModel) {
    const conditions: unknown[] = [];
    filterModel.items.forEach((item) => {
        const field = item.field;
        const operator = item.operator;
        const value = item.value;

        switch (field) {
            case 'name':
                conditions.push({
                    name: {
                        [operator]: value,
                    },
                });
                break;
            case 'class': {
                const matchedValue = value.match(/(.*)\((.*)\)$/);
                const className = matchedValue ? matchedValue[1] : value;
                const schoolYear = matchedValue ? matchedValue[2] : null;

                conditions.push({
                    studentProfile: {
                        class: {
                            className: {
                                [operator]: className.trim(),
                            },
                            ...(schoolYear
                                ? {
                                      schoolYear: {
                                          ['equals']: schoolYear,
                                      },
                                  }
                                : {}),
                        },
                    },
                });
                break;
            }
            case 'number':
                conditions.push({
                    studentProfile: {
                        studentNumber: {
                            [operator]: value,
                        },
                    },
                });
                break;
            case 'email':
                conditions.push({
                    email: {
                        [operator]: value,
                    },
                });
                break;
        }
    });

    return conditions;
}
